import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { tenantContextService } from '../services/api';
import '../styles/Auth.css';

const mapContextError = (error) => {
  const status = error?.response?.status;
  if (status === 404) {
    return 'Ambiente nao encontrado para este link.';
  }
  return error?.response?.data?.detail || 'Nao foi possivel carregar o contexto do ambiente.';
};

const mapLoginError = (error) => {
  const status = error?.response?.status;
  const detail = String(error?.response?.data?.detail || '').toLowerCase();

  if (status === 403 || detail.includes('nao possui acesso') || detail.includes('sem acesso')) {
    return 'Seu usuario nao possui acesso a este ambiente.';
  }

  if (status === 401) {
    return 'Email ou senha invalidos.';
  }

  if (detail) {
    return error?.response?.data?.detail;
  }

  return 'Nao foi possivel realizar o login neste ambiente.';
};

const TenantContextLoginPage = () => {
  const { tenant_slug: tenantSlugParam } = useParams();
  const tenantSlug = String(tenantSlugParam || '').trim();
  const navigate = useNavigate();
  const { login } = useAuth();

  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [loadingContext, setLoadingContext] = useState(true);
  const [tenantContext, setTenantContext] = useState(null);
  const [contextError, setContextError] = useState('');

  useEffect(() => {
    let active = true;

    const loadContext = async () => {
      setLoadingContext(true);
      setContextError('');
      setTenantContext(null);

      try {
        const response = await tenantContextService.getTenantContext(tenantSlug);
        if (!active) return;

        const payload = response?.data || null;
        setTenantContext(payload);

        const tenantId = String(payload?.tenant_id || '').trim();
        if (tenantId) {
          localStorage.setItem('current_tenant_id', tenantId);
          localStorage.removeItem('tenant_id');
          localStorage.removeItem('selected_tenant_id');
        }
      } catch (requestError) {
        if (!active) return;
        setContextError(mapContextError(requestError));
      } finally {
        if (active) {
          setLoadingContext(false);
        }
      }
    };

    if (!tenantSlug) {
      setLoadingContext(false);
      setContextError('Link de ambiente invalido.');
    } else {
      loadContext();
    }

    return () => {
      active = false;
    };
  }, [tenantSlug]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (!tenantContext?.tenant_id) {
      setError('Ambiente invalido para login.');
      return;
    }

    setLoading(true);
    try {
      const tenantId = String(tenantContext.tenant_id || '').trim();
      await login(email, senha, { tenantId });
      navigate('/inicio');
    } catch (requestError) {
      setError(mapLoginError(requestError));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Entrar no Ambiente</h1>
          <p>{tenantContext?.display_name || 'Carregando ambiente...'}</p>
        </div>

        {loadingContext ? <div className="alert alert-success">Carregando contexto do ambiente...</div> : null}
        {contextError ? <div className="alert alert-error">{contextError}</div> : null}
        {error ? <div className="alert alert-error">{error}</div> : null}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="seu@email.com"
              required
              disabled={loading || loadingContext || !!contextError}
            />
          </div>

          <div className="form-group">
            <label htmlFor="senha">Senha</label>
            <input
              id="senha"
              type="password"
              value={senha}
              onChange={(event) => setSenha(event.target.value)}
              placeholder="Digite sua senha"
              required
              disabled={loading || loadingContext || !!contextError}
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading || loadingContext || !!contextError}
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        <div className="auth-links">
          <Link to={`/t/${tenantSlug}/cadastro`} className="link">
            Primeiro acesso neste ambiente
          </Link>
          <Link to="/login" className="link">
            Voltar para login padrao
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TenantContextLoginPage;
